import { BCMSRecord, Workflow, useGlobalController } from "@bcm-dev/bcms-vite";
import AcceptedDisclosuresPage from "components/pages/AcceptedDisclosuresPage";
import { Disclosure } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <AcceptedDisclosuresPage /> ];

/**
 * @function AcceptedDisclosuresWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the Accepted Disclosures page.
 * 
 * Setting constructor example for state captures:
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
  detail: { 
    value: { 
      disclosures: [
        { id: "0", title: "some title", date: "-10" }
      ]
    } 
  } 
}));
 */
export default function AcceptedDisclosuresWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
        const disclosuresObj = record.disclosures ?? [];
        const disclosures = disclosuresObj.reduce((acc, disclosure) => {
            const disclosureInstance = Disclosure.initByID(disclosure.id);
            const mergedObj = { ...disclosureInstance.record, ...disclosure };
            const mergedDisclosure = Disclosure.init(mergedObj);
            acc.push(mergedDisclosure);
            return acc;
        }, []);
        const disclosuresProp = disclosures.length > 0 ? { disclosures: disclosures } : {};

        // Return the new workflow default object.
        return { 
            ...getDefault(controller),
            ...disclosuresProp
        };
    };

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor([ Disclosure ], controller);
    // Initalize mobile devices and accounts for the user.
    const disclosures = Disclosure.initAll();
    
    // Return the default workflow state
    return { 
        disclosures: disclosures
    };
};